import React from 'react';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import { updateProjectInfo } from 'js/actions';
import { Stack } from 'new/elements/Stack';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { CARD_TYPE_PROJECT } from 'js/constants/cardTypes';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';

interface ProjectDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  data: any;
  onCloseDrawer?(): void;
}

const Connection = ResourceDetailHeader.TopContent.Connection;

export const ProjectDetailHeader = (props: ProjectDetailHeaderProps) => {
  const { readOnly, adminAccess, data, onCloseDrawer } = props;
  const dispatch = useAppDispatch();

  if (!data) return null;

  const updateInfo = (id: number, info = {}) => {
    dispatch(updateProjectInfo(data.id, info));
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      updateInfo={updateInfo}
      onCloseDrawer={onCloseDrawer}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <Connection resourceType={CARD_TYPE_PROJECT} data={data} />
            <ChipWithCopy tooltipTitle="Copy Project ID" toCopy={data.id}>
              ID {data.id}
            </ChipWithCopy>
          </Stack>
        </Stack>
      </ResourceDetailHeader.TopContent>
    </ResourceDetailHeader>
  );
};
